import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import SatToolTip from '@components/common/satUI/SatToolTip';
import SatCheckBox from '@components/common/satUI/SatCheckBox';

import { toNumber } from '@common/utils/index';
import { toast } from 'react-toastify';
import { showModal } from '@store/actions/commonAction';

const OptionalRiderContract = props => {
  const {
    value = [],
    optionalRiderList = [],
    optionalRidersTooltip = [],
    planEstablishProduct,
    customerList,
    onChange,
  } = props;

  const [optionalAllList, setOptionalAllList] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');

  const [mainProduct, setMainProduct] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (optionalRiderList.length > 0) {
      setOptionalAllList(
        optionalRiderList.map(optionalRider => {
          const tooltip = optionalRidersTooltip.find(
            tooltip =>
              tooltip.keyName.split('.')[2].replace('is', '') ===
              optionalRider.code,
          );
          if (tooltip) {
            return { ...optionalRider, tooltip: tooltip.value };
          } else {
            return optionalRider;
          }
        }),
      );
    } else {
      if (optionalAllList.length > 0) {
        setOptionalAllList([]);
      }
    }
  }, [optionalRiderList, optionalRidersTooltip]);

  useEffect(() => {
    if (planEstablishProduct.length > 0) {
      const product = planEstablishProduct.find(
        item => item.mainPolicyRiderTypeCode === 'P',
      );

      setMainProduct(product);

      /**
       * 가입당시유가족연금전환 조건 체크(5천만원 이상 제한조건 상품에 대한 처리)
       */
      if (parseInt(toNumber(product.faceAmount)) > 0) {
        const optionalRiders = optionalRiderList.filter(
          optionalRider => optionalRider.fixFaceAmount,
        );

        if (optionalRiders.length > 0) {
          let filterValue = value.map(item => item.code);
          optionalRiders.forEach(optionalRider => {
            if (
              parseInt(toNumber(product.faceAmount)) <
              optionalRider.fixFaceAmount / 10000
            ) {
              filterValue = filterValue.filter(v => v !== optionalRider.code);
            } else {
              if (!filterValue.includes(optionalRider.code)) {
                filterValue.push(optionalRider.code);
              }
            }
          });

          onChange(filterValue);
        }
      }

      /**
       * 기부보험 조건(특약이 없어야 부가가능)
       */
      if (
        optionalRiderList.filter(optionalRider =>
          $utils.checkPlanFlag(optionalRider.isExclusive),
        ).length > 0 &&
        value.find(item => $utils.checkPlanFlag(item.isExclusive)) &&
        planEstablishProduct.filter(
          item => item.mainPolicyRiderTypeCode !== 'P',
        ).length > 0
      ) {
        onChange(
          value.filter(item => !item.isExclusive).map(item => item.code),
        );

        toast(
          '주계약 외 특약이 부가된 경우 기부보험특약을 부가할 수 없습니다.',
        );
      }

      // 여명급부 부가 불가
      if (
        optionalRiderList.filter(optionalRider =>
          $utils.checkPlanFlag(optionalRider.chkInsuredPerson),
        ).length > 0 &&
        value.find(item => $utils.checkPlanFlag(item.chkInsuredPerson)) &&
        customerList.filter(item => item.hasOwnProperty('custNo')).length > 1
      ) {
        const [owner, insuredPerson] = customerList;
        if (owner.custNo !== insuredPerson.custNo) {
          onChange(
            value
              .filter(item => !$utils.checkPlanFlag(item.chkInsuredPerson))
              .map(item => item.code),
          );
        }
      }
    }
  }, [planEstablishProduct]);

  useEffect(() => {
    // 여명급부 부가 불가
    if (
      optionalRiderList.filter(optionalRider =>
        $utils.checkPlanFlag(optionalRider.chkInsuredPerson),
      ).length > 0 &&
      value.find(item => $utils.checkPlanFlag(item.chkInsuredPerson)) &&
      customerList.filter(item => item.hasOwnProperty('custNo')).length > 1
    ) {
      const [owner, insuredPerson] = customerList;
      if (owner.custNo !== insuredPerson.custNo) {
        onChange(
          value
            .filter(item => !$utils.checkPlanFlag(item.chkInsuredPerson))
            .map(item => item.code),
        );
      }
    }
  }, [customerList]);

  const handleOptionalRiders = (checked, code) => {
    if (code === 'Z30900100') {
      if (checked) {
        dispatch(
          showModal({
            visible: true,
            type: 'confirm',
            msg: '사후정리특약은 성인 1인 이상이 사망 시 수익자로 지정되어야 가입 가능합니다.\n가입을 진행하시겠습니까?',
            onOk: { label: '예', handle: () => onChange(value.map(item => item.code).concat(code)) },
            onCancel: { label: '아니요', handle: () => onChange(value.map(item => item.code).filter(v => v !== code)) },
          }),
        );
      } else {
        onChange(value.map(item => item.code).filter(v => v !== code));
      }
    } else {
      onChange(
        checked
          ? value.map(item => item.code).concat(code)
          : value.map(item => item.code).filter(v => v !== code),
      );
    }  
  };
  
  const checkFixedOption = option => {
    const { isFixed = false, fixFaceAmount = 0, code = '' } = option;

    if ($utils.checkPlanFlag(isFixed)) {
      if (code === 'Z30000100' && (parseInt(toNumber(mainProduct.faceAmount)) > 0) && (parseInt(toNumber(mainProduct.faceAmount)) < fixFaceAmount / 10000)) {
        return false;
      } else {
        return true;
      }
    } else if (mainProduct && fixFaceAmount > 0) {
      if (parseInt(toNumber(mainProduct.faceAmount)) > 0) {
        if (
          parseInt(toNumber(mainProduct.faceAmount)) >=
          fixFaceAmount / 10000
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const checkDisableOption = option => {
    const {
      fixFaceAmount = 0,
      isExclusive = false,
      chkInsuredPerson = false,
    } = option;
    if (fixFaceAmount > 0) {
      if (parseInt(toNumber(mainProduct.faceAmount)) > 0) {
        if (
          parseInt(toNumber(mainProduct.faceAmount)) <
          fixFaceAmount / 10000
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    if ($utils.checkPlanFlag(isExclusive)) {
      if (
        planEstablishProduct.filter(
          item => item.mainPolicyRiderTypeCode !== 'P',
        ).length > 0
      ) {
        return true;
      }
    }

    if ($utils.checkPlanFlag(chkInsuredPerson)) {
      if (
        customerList.filter(item => item.hasOwnProperty('custNo')).length > 1
      ) {
        const [owner, insuredPerson] = customerList;
        return owner.custNo !== insuredPerson.custNo;
      }
    }

    return false;
  };

  const handleValidNotiModal = option => {
    if ($utils.checkPlanFlag(option.isExclusive)) {
      toast('주계약 외 특약이 부가된 경우 기부보험특약을 부가할 수 없습니다.');
      return;
    }

    if ($utils.checkPlanFlag(option.chkInsuredPerson)) {
      toast('계약자 피보험자가 상이하여 여명급부특약 부가 불가합니다.');
      return;
    }

    return;
  };

  return (
    <>
      <div className="tit-area">
        <h2>제도성 특약</h2>
      </div>
      {optionalAllList.length > 0 ? (
        <div className="list-sp">
          {optionalAllList.map((option, index) => {
            return (
              <div key={index} className="box-item-tootip">
                <SatCheckBox
                  value={[value.map(item => item.code).includes(option.code)]}
                  options={[
                    {
                      label: option.dispName,
                      value: option.code,
                      isFixed: checkFixedOption(option),
                    },
                  ]}
                  disabled={checkDisableOption(option)}
                  onChange={value => handleOptionalRiders(value, option.code)}
                  onValidNotiModal={() => handleValidNotiModal(option)}
                />
                {'tooltip' in option && (
                  <SatToolTip
                    show={selectedOption === option.code}
                    setShow={flag => setSelectedOption(flag ? option.code : '')}
                    toolTips={[
                      {
                        title: option.dispName,
                        message: () => <p>{option.tooltip}</p>,
                      },
                    ]}
                  />
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <table className="tbl-sty1 main-contract">
          <tbody>
            <tr>
              <td colSpan="4" className="nodata">
                주계약 선택 후 제도성 특약을 선택하실 수 있습니다.
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </>
  );
};

export default React.memo(OptionalRiderContract);
